import './styles.scss'

import { useTranslation } from 'react-i18next'

import Footer from '@/components/Layout/Footer'
import Header from '@/components/PublicHeader/Header'
import ScrollToTop from '@/components/ScrollToTop'
import useAdobeAnalysis from '@/hooks/useAdobeAnalysis'
import useDocumentTitle from '@/hooks/useDocumentTitle'
import { PAGE_TYPES } from '@/libs/constants/adobeAnalytics'
import { parseHtml } from '@/libs/utils/common'

const Imprint = () => {
  useDocumentTitle('pageTitle.imprint')
  const { t, i18n } = useTranslation()

  useAdobeAnalysis(null, {
    pageName: 'Imprint',
    pageId: '31',
    pageType: PAGE_TYPES.POLICY,
  })

  const renderSections = () => {
    const sections = []
    let index = 1

    while (i18n.exists(`imprint.section${index}`)) {
      sections.push(
        <div key={`section-${index}`} className="imprint-section">
          <section>{parseHtml(t(`imprint.section${index}`))}</section>
        </div>,
      )
      index += 1
    }

    const addedDividerSections = sections.reduce((previous, current, index) => {
      return [
        previous,
        <div key={`divide-${index + 0}`} className="row">
          <hr className="hrbold" />
        </div>,
        current,
      ]
    })

    return addedDividerSections
  }

  return (
    <>
      <Header />
      <ScrollToTop />
      <div className="imprint-wrapper">
        <div className="imprint-wrapper__container-width">
          {renderSections()}
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Imprint
